export enum AssessmentStatusEnum {
  "Aberto" = 1,
  "Finalizado" = 2,
  "Vencido" = 3,
}
